import React from 'react';
import { Skeleton } from 'antd';

export const ProductListSkeleton: React.FC = () => {
  const placeholders = Array.from({ length: 4 });

  return (
    <>
      {placeholders.map((_, index) => (
        <div
          key={index}
          className="flex gap-3 p-3 border border-solid border-[var(--fett-product-card-border)] rounded "
        >
          <Skeleton.Avatar
            active
            shape="square"
            size={46}
            className="!rounded-md !w-[46px] !h-[46px] flex-shrink-0"
          />
          <div className="flex-1 flex flex-col gap-2 min-w-0">
            <Skeleton.Input active size="small" className="!w-3/4 !min-w-0" />
            <Skeleton.Input active size="small" className="!w-1/2 !min-w-0" />
          </div>
        </div>
      ))}
    </>
  );
};
